export const SET_COLORS = 'SET_COLORS'
export const SET_COLORS_SUCCESS = 'SET_COLORS_SUCCESS'
export const SET_COLORS_FAILED = 'SET_COLORS_FAILED'

export const SET_THEME = 'SET_THEME'
